import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1ClassroomdisciplineClassModulesQueryOptions,
  useDeleteApiV1ClassroomdisciplineClassModulesId,
} from '@/shared/api/generated';

/**
 * Hook para excluir um módulo de aula.
 *
 * Envolve o mutation gerado pelo Kubb para
 * `DELETE /api/v1/classroomdiscipline/class-modules/{id}` e invalida o cache da
 * listagem após a exclusão bem-sucedida.
 *
 * @example
 * ```tsx
 * const deleteModule = useDeleteClassModule();
 * deleteModule.mutate({ id: 1 });
 * ```
 */
export function useDeleteClassModule() {
  const queryClient = useQueryClient();

  return useDeleteApiV1ClassroomdisciplineClassModulesId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1ClassroomdisciplineClassModulesQueryOptions());
      },
    },
  });
}
